<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2021-01-18 17:38:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/addresslist/index.vue
-->
<template>
  <div>
    <title-bar-back :title="'收货地址'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 无数据 -->
    <none-list v-if="false" />
    <!-- 有数据 -->
    <!-- <van-pull-refresh v-model="loading" @refresh="onRefresh"> -->
    <van-list
      v-model="loading"
      :finished="!getUserAddressList.hasNextPage"
      @load="onLoad"
    >
      <div class="address_lists">
        <address-item
          v-for="(item, index) in getUserAddressList.rows"
          :key="index"
          :rows="item"
          :rowIndex="index"
          @editAddress="editAddress"
          @clickAddressItem="clickAddressItem"
        />
      </div>
    </van-list>
    <!-- </van-pull-refresh> -->
    <!-- 底部按钮 -->
    <add-btn @addAddress="addAddress" />
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import NoneList from "./components/NoneList";
import AddBtn from "./components/AddBtn";
import AddressItem from "./components/AddressItem";
export default {
  name: "AddressList",
  components: {
    TitleBarBack,
    NoneList,
    AddBtn,
    AddressItem
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    getUserAddressList() {
      return this.$store.getters.getUserAddressList;
    }
  },
  created() {
    this.getData();
  },
  // mounted() {
  //   console.log(this.$route.query, "query");
  // },
  methods: {
    back() {
      this.$router.back();
    },
    // getUserAddress
    getData(pageIndex = 1) {
      const params = {
        pageNo: pageIndex,
        pageSize: 20
      };
      this.$store
        .dispatch("mine/getUserAddress", { params })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onRefresh() {
      this.getData();
    },
    onLoad() {
      // this.loading = false;
      if (
        this.getUserAddressList.hasNextPage &&
        this.getUserAddressList.pageNo <= this.getUserAddressList.pageCount &&
        !this.loading
      ) {
        this.loading = true;
        const pageIndex = this.getUserAddressList.pageNo + 1;
        this.getData(pageIndex);
        // console.log("上拉完毕");
      }
    },
    // 新增收货人
    addAddress() {
      this.$router.push({
        path: "/mine/addeditaddress",
        query: {
          ...this.$route.query,
          key: "新增收货人"
        }
      });
    },
    // 新增收货人
    editAddress(id, rowIndex) {
      this.$router.push({
        path: "/mine/addeditaddress",
        query: {
          ...this.$route.query,
          key: "编辑收货人",
          id: id,
          rowIndex: rowIndex
        }
      });
    },
    // 点击收货人列
    clickAddressItem(items) {
      if (this.$route.query.previousPage === "pur") {
        localStorage.setItem("pur-address", JSON.stringify(items));
        this.$router.back(-1);
        return;
      }
      if (this.$route.query.previousPage === "exchangeMilkPur") {
        localStorage.setItem(
          "exchange-milk-pur-address",
          JSON.stringify(items)
        );
        this.$router.back(-1);
        return;
      }
      if (this.$route.query.previousPage === "milkPlan") {
        if (this.$route.query.switchPur === "one") {
          localStorage.setItem(
            "exchange-milk-plan-one-address",
            JSON.stringify(items)
          );
          localStorage.setItem(
            "exchange-milk-plan-one-parcelId",
            this.$route.query.parcelId
          );
        } else {
          localStorage.setItem(
            "exchange-milk-plan-all-address",
            JSON.stringify(items)
          );
        }
        this.$router.back(-1);
        return;
      }
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.title_right {
  width: 36px;
}
.address_lists {
  background: #fff;
  padding-bottom: 70px;
}
</style>
